import requestor from "../../requestor";

export default class CouponApi {
  all = (page = 1, code = null, item_id = null) =>
    requestor.get("/coupon/all", {
      page,
      filter: {
        code: code,
        item_id: item_id,
      },
    });
  one = (id) => requestor.get("/coupon/one", { id: id });
  create = (form) => requestor.post("/coupon/create", form);
  save = (form) => requestor.patch("/coupon/save", { Coupon: form });
  remove = (id) => requestor.delete("/coupon/delete", { id: id });
}
